export { default } from "./IntegrationTile";
